import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Typography, Grid } from '@material-ui/core';
import SingleVideo from '../../../../components/Video/Video';
import { useTranslation } from 'react-i18next';
import MessageContainer from './styles';
import Animation from '../../../../components/Animation';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Logo from '../../../../components/logo';
import { scrollToDirectorMessageSelector } from '../../selectors';

const Message = props => {
	const refMessage = useRef(null);
	const { t, i18n } = useTranslation();
	const theme = useTheme();
	const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

	useEffect(() => {
		if (props.scrollToDirectorMessage) {
			refMessage.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToDirectorMessage]);

	return (
		<MessageContainer ref={refMessage}>
			<Grid container spacing={isSmall ? 5 : 10} alignItems="center">
				<Grid item xs={12} sm={6}>
					<SingleVideo
						src={
							i18n.language === 'es'
								? '/static/media/videos/promo-es.mp4'
								: '/static/media/videos/promo-en.mp4'
						}
						autoPlay={''}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<Animation animateIn="fadeInRight">
						<Typography variant="h2" color="textPrimary">
							{t('general.message.title')}
						</Typography>
					</Animation>
					<Animation animateIn="fadeIn" duration={2}>
						<Typography variant="body1" color="textPrimary">
							{t('general.message.paragraphFirst')}
						</Typography>
						<Typography variant="body1" color="textPrimary" paragraph>
							{t('general.message.paragraphSecond')}
						</Typography>
						<Typography variant="body1" color="textPrimary">
							{t('general.message.paragraphThird')}
						</Typography>
						<Typography variant="body1" color="textPrimary">
							{t('general.message.paragraphFourth')}
						</Typography>
						<Logo />
					</Animation>
				</Grid>
			</Grid>
		</MessageContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToDirectorMessage: scrollToDirectorMessageSelector(state)
	};
};

export default connect(mapStateToProps)(Message);
